import { List, Map } from "immutable";

export default function useImmutable<T extends List<any> | Map<any, any>>(
  immutable: T | null | undefined
) {
  return immutable ? immutable.toJS() : null;
}
